import React from 'react';

import {
  serializeWhatsNewCarouselPayload,
  serializeWhatsNewCarouselPreviewPayload,
  whatsNewCarouselPayloadDownloadFilename,
} from '~/utils/societePayloadBuilder/whatsNewCarousel/buildPayload';
import { createDefaultWhatsNewCarouselState } from '~/utils/societePayloadBuilder/whatsNewCarousel/defaults';
import { hasWhatsNewCarouselProgress } from '~/utils/societePayloadBuilder/whatsNewCarousel/hasProgress';
import { parseWhatsNewCarouselPayload } from '~/utils/societePayloadBuilder/whatsNewCarousel/parsePayload';
import type { WhatsNewCarouselPayloadBuilderState } from '~/utils/societePayloadBuilder/whatsNewCarousel/types';
import { validateWhatsNewCarouselPayload } from '~/utils/societePayloadBuilder/whatsNewCarousel/validatePayload';

import PayloadBuilderJsonPreview from '../JsonPreview';
import StandalonePayloadActions from '../StandalonePayloadActions';
import StandalonePayloadBuilderPage from '../StandalonePayloadBuilderPage';

import WhatsNewCarouselPayloadBuilderForm from './WhatsNewCarouselPayloadBuilderForm';

interface WhatsNewCarouselPayloadBuilderPageProps {
  onProgressChange?: (hasProgress: boolean) => void;
}

export default function WhatsNewCarouselPayloadBuilderPage({
  onProgressChange,
}: WhatsNewCarouselPayloadBuilderPageProps) {
  return (
    <StandalonePayloadBuilderPage<WhatsNewCarouselPayloadBuilderState>
      onProgressChange={onProgressChange}
      createDefaultState={createDefaultWhatsNewCarouselState}
      hasProgress={hasWhatsNewCarouselProgress}
      parsePayload={parseWhatsNewCarouselPayload}
      validate={validateWhatsNewCarouselPayload}
      renderActions={(state, isValid, fullWidth) => (
        <StandalonePayloadActions
          state={state}
          isValid={isValid}
          fullWidth={fullWidth}
          serialize={serializeWhatsNewCarouselPayload}
          getFilename={whatsNewCarouselPayloadDownloadFilename}
          payloadName="What's New Carousel"
        />
      )}
      renderForm={(props) => <WhatsNewCarouselPayloadBuilderForm {...props} />}
      renderPreview={(state, borderSoft, maxHeight) => (
        <PayloadBuilderJsonPreview
          state={state}
          serialize={serializeWhatsNewCarouselPreviewPayload}
          borderSoft={borderSoft}
          maxHeight={maxHeight}
        />
      )}
    />
  );
}
